import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const upsertBankAccount = async (data) => {
  const res = await axiosInstance.post("/api/payroll/bank-account", data);
  return res.data;
};

export const getAllBankAccounts = async () => {
  const res = await axiosInstance.get("/api/payroll/bank-account");
  return res.data;
};

export const getBankAccountsByStaff = async (staffId) => {
  const res = await axiosInstance.get(`/api/payroll/bank-account/staff/${staffId}`);
  return res.data;
};

export const deleteBankAccount = async (id) => {
  const res = await axiosInstance.delete(`/api/payroll/bank-account/${id}`);
  return res.data;
};
